import { Inject, Injectable } from '@angular/core';
import { availabilityDataResponse, contributionDataResponse, ContributionErrorModal, IsNewPaymentResponse, managementPayLoad } from '@src/app/core/models/contribution.model';
import { AJSGiftCardsCommonsModalService, GiftCardsCommonsModalServiceType } from '@shared/services/upgrades/ib-gift-cards-commons-modal-service-bridge.service';
import { GiftCardsGenericProxyService } from '@src/app/core/services/ib-gift-cards-generic-proxy/ib-gift-cards-generic-proxy.service';
import { GiftCardsSessionStorageService } from '@src/app/core/services/ib-gift-cards-session-storage/gift-cards-session-storage.service';
import { GiftCardsAppConstant } from '@src/ib-gift-cards-constants';
import { firstValueFrom } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { GiftCardsAppConstants } from '@src/app/shared/constants/ib-gift-cards-constants';
import { AJSGiftCardsCommonsKeepAliveUtilsService, GiftCardsCommonsKeepAliveUtilsServiceType } from '@shared/services/upgrades/ib-gift-cards-keep-alive-utils-bridge.service';
import { AJSGiftCardsCommonsNewHttpUtilsErrorService, GiftCardsCommonsNewHttpUtilsErrorServiceType } from '@shared/services/upgrades/ib-gift-cards-commons-new-http-utils-error-bridge.service';
import { IbCModalService } from '@shared/modals/services/ib-gift-cards-modal-service/ib-gift-cards-modal.service';
import { ibGiftCardContributionErrorModal } from '@src/app/shared/modals/contribution/ib-gift-cards-contribution-error-modal/ib-gift-cards-contribution-error-modal';
import { IbGiftCardsRedirectionLandingService } from '@shared/services/ib-gift-cards-redirection-landing/ib-gift-cards-redirection-landing.service';
import { TranslateService } from '@ngx-translate/core';
import { IbCGenericModalComponent } from '@src/app/shared/modals/generic-modal/ib-commons-generic-modal.component';

@Injectable({
    providedIn: 'root'
})
export class IbGiftCardsContributionService {
    contributionDataResponse: contributionDataResponse;
    availabilityDataResponse: availabilityDataResponse;
    formIsSubmitted: boolean = false;
    constructor (
        @Inject(AJSGiftCardsCommonsModalService) private  CommonsModalService: GiftCardsCommonsModalServiceType,
        @Inject(AJSGiftCardsCommonsKeepAliveUtilsService) private CommonsKeepAliveUtilsService: GiftCardsCommonsKeepAliveUtilsServiceType,
        @Inject(AJSGiftCardsCommonsNewHttpUtilsErrorService) private CommonsNewHttpUtilsErrorService: GiftCardsCommonsNewHttpUtilsErrorServiceType,
        private GiftCardsGenericProxyService: GiftCardsGenericProxyService,
        private GiftCardsSessionStorageService: GiftCardsSessionStorageService,
        private IbCModalService: IbCModalService,
        private translateService: TranslateService,
        private RedirectionLandingService: IbGiftCardsRedirectionLandingService
        
    ) { }
    openComponentModal = (dataModal) => {
        const modalRef = this.IbCModalService.showGenericComponentModal(ibGiftCardContributionErrorModal);

        if (modalRef && modalRef.componentInstance) {
            (modalRef.componentInstance as { model: any }).model = { dataModal };
            modalRef.result.then(
                (result) => {
                    this.RedirectionLandingService.redirection(this.getParameterByName('market').toLowerCase(), this.getParameterByName('language').toUpperCase());
                }
            );
        }
    };
    getContributionData = () => {
        const code = this.getParameterByName('code');
        const id = this.getParameterByName('id');
        const endPoint = GiftCardsAppConstant.DEFAULT_ENDPOINTS.AVAILABILITYPERMISSION.replaceAll('{code}', code).replaceAll('{id}', id);
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
        return new Promise ((resolve) => {
            const getContributionDataSuccess = (response: any): void => {
                if (response && response.code === 200) {
                    this.contributionDataResponse = response.data;
                    this.CommonsModalService.finishWaiting();
                    resolve(response.data);
                } else {
                    getContributionDataError(response);
                }
            };
            const getContributionDataError = (error: CommonsErrorsModel.ErrorDataGeneral): void => {
                this.CommonsModalService.finishWaiting();
                const errorCode = error?.data?.error?.code;
                const errorModalTranslateKeys: ContributionErrorModal =  GiftCardsAppConstants.CONTRIBUTION_ERROR_MODAL_DATA[errorCode];
                if(errorModalTranslateKeys){    
                    let dataErrorModal: ContributionErrorModal =
                        {
                            TITLE:  this.getInstantTranslate(errorModalTranslateKeys.TITLE),
                            BODY: this.getInstantTranslate(errorModalTranslateKeys.BODY)
                        }
                    ;
                    this.openComponentModal(dataErrorModal);
                }else {
                    this.IbCModalService.showGenericComponentModal(IbCGenericModalComponent);
                }
            };
            firstValueFrom(this.GiftCardsGenericProxyService.getGeneric(`${endPoint}` )).then(getContributionDataSuccess).catch(getContributionDataError);
        });
    };
    getAvailabilityData = (flowId?: string): angular.IPromise<Types.AvailabilityGiftCards|any> => {
        const endpoint = flowId ? GiftCardsAppConstant.DEFAULT_ENDPOINTS.AVAILABILITY_CONTRIBUTION.replaceAll('{{flowId}}', flowId) : GiftCardsAppConstant.DEFAULT_ENDPOINTS.AVAILABILITY;
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
        const headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': '*/*'
            }
        };
        return new Promise ((resolve, reject)=>{
            const postData = {
                type: 'GIFTCARD',
                market: GiftCardsAppConstant.market
            };

            const getAvailabilitySuccess = (response: Types.ProxyResponse): void => {
                if (response && response.code === 200) {
                    const data: availabilityDataResponse = <availabilityDataResponse>response.data;
                    this.GiftCardsSessionStorageService.remove('giftCardspaymentContextResponse');
                    this.GiftCardsSessionStorageService.set('giftCardsFlowId', data.flowId);
                    this.GiftCardsSessionStorageService.set('flowId', data.flowId);
                    this.availabilityDataResponse = data;
                    this.CommonsModalService.finishWaiting();
                    resolve(response.data);
                } else {
                    getAvailabilityError(response);
                }
            };
            const getAvailabilityError = (error: CommonsErrorsModel.ErrorDataGeneral) :void => {
                this.CommonsModalService.finishWaiting();
                const errorUri = '/error';
                let baseUrl = window.location.href;
                let paymentsFinalUrl = baseUrl.replace(baseUrl.split('#!')[1], errorUri);
                window.location.href = paymentsFinalUrl;
            };
            firstValueFrom(this.GiftCardsGenericProxyService.postGeneric(`${endpoint}`, postData, headerConfig )).then(getAvailabilitySuccess).catch(getAvailabilityError);
        });
    };

    getNewPaymentAvailability = (): angular.IPromise<IsNewPaymentResponse|any> => {
        const endpoint = GiftCardsAppConstants.DEFAULT_ENDPOINTS.NEW_PAYMENT_AVAILABILITY.replace('{market}', this.getParameterByName('market'));

        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);

        return new Promise((resolve, reject) => {
            const resolveNewPaymentAvailability = (response: Types.ProxyResponse): void => {
                if (response && response.code === 200) {
                    this.CommonsModalService.finishWaiting();
                    resolve(response.data as IsNewPaymentResponse);
                } else {
                    handleNewPaymentAvailabilityError(response);
                }
            };
            const handleNewPaymentAvailabilityError = (error: CommonsErrorsModel.ErrorDataGeneral): void => {
                this.CommonsModalService.finishWaiting();
                resolve(false);
            };
            firstValueFrom(this.GiftCardsGenericProxyService.getGeneric(`${endpoint}`))
                .then(resolveNewPaymentAvailability)
                .catch(handleNewPaymentAvailabilityError);
        });
    };
    private checkPermanentUserAndGoPayment = async (): Promise<void> => {
        this.CommonsModalService.finishWaiting();
        const isNewPaymentAvailiability = await this.getNewPaymentAvailability();
        const paymentsURI = isNewPaymentAvailiability ? GiftCardsAppConstants.PAGES_ROUTES.NEWPAYMENTS : GiftCardsAppConstants.PAGES_ROUTES.PAYMENTS;
        let baseUrl = window.location.href;
        let paymentsFinalUrl = baseUrl.replace(baseUrl.split('#!')[1], paymentsURI);
        window.location.href = paymentsFinalUrl;
    };

    updatePaymentContext = async (flowId: string): Promise<any | Types.ErrorResponse> => {
        const endpoint = GiftCardsAppConstants.DEFAULT_ENDPOINTS.UPDATE_PAYMENT_CONTEXT.replace('{flowId}', flowId);
        const headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': '*/*'
            }
        };
        const postData = {
            'redirection': {
                'success': {
                    'url': endpoint,
                    'data': '',
                    'method': ''
                },
                'failure': {
                    'url': endpoint,
                    'data': '',
                    'method': ''
                }
            }
        };
        return new Promise ((resolve, reject)=> {
            const updatePaymentContextSuccess = async (response: Types.ProxyResponse) => {
                if (response && response.code === 200) {
                    await this.checkPermanentUserAndGoPayment();
                    resolve(response);
                } else {
                    updatePaymentContextError(response);
                }
                

            };
            const updatePaymentContextError = (error: CommonsErrorsModel.ErrorDataGeneral) => {
                this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
            };

            firstValueFrom(this.GiftCardsGenericProxyService.postGeneric(`${endpoint}`, postData, headerConfig))
                .then(updatePaymentContextSuccess)
                .catch(updatePaymentContextError);

        });
    };

    putManagement = (managementPayLoad: managementPayLoad): void => {
        const headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': '*/*'
            }
        };                                       
        this.GiftCardsSessionStorageService.set('giftCardsConfigurationInfo', this.generateGiftCardsConfigurationInfo(managementPayLoad)); 
        const flowId = this.contributionDataResponse.flowId;
        const endpoint = GiftCardsAppConstants.DEFAULT_ENDPOINTS.GIFCARD.replace('{flowId}', flowId);
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
        const putManagementSuccess = (response: any): void => {
            if (response && response.code === 200) {
                this.CommonsModalService.finishWaiting();
                this.updatePaymentContext(flowId);
                this.CommonsKeepAliveUtilsService.initKeepAlive();
                
            } else {
                putManagementError(response);
            }
        };

        const putManagementError = (error: any): void => {
            this.CommonsModalService.finishWaiting();
            this.IbCModalService.showGenericComponentModal(IbCGenericModalComponent);
        };

        firstValueFrom(this.GiftCardsGenericProxyService.putGeneric(endpoint, managementPayLoad, headerConfig))
            .then(putManagementSuccess)
            .catch(putManagementError);
    };

    getParameterByName = (name: string, url?: string): string => {
        if (!url) url = window.location.href;
        name = name.replace(/([\\[\]])/g, '\\$1');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'gi' );
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return null;
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    getContributionSummaryModel = ({amountToContribute}) => {
        return {
            cardName: this.contributionDataResponse.giftCardName,
            amountToContribute: `${amountToContribute.toString().replace('.', this.contributionDataResponse.currency.decimalSeparator).replace(',', this.contributionDataResponse.currency.decimalSeparator)} ${this.contributionDataResponse.currency.symbol}`,
            deadLineToContribute: this.contributionDataResponse.deliveryDate.split(' ')[0],
            totalAmount: `${(Number(amountToContribute) + this.contributionDataResponse.amount).toString().replace('.', this.contributionDataResponse.currency.decimalSeparator).replace(',', this.contributionDataResponse.currency.decimalSeparator)} ${this.contributionDataResponse.currency.symbol}`
        };
    };

    checkFormatDate (dateToCheck): string {
        const trakingCode: string = this.GiftCardsSessionStorageService.get('TrackingCode');
        const language = trakingCode.split('/')[0];
        const isInvalidDate: boolean = language === 'es';

        if(!isInvalidDate) {
            return dateToCheck;
        }else {
            const [datePart, ...time] = dateToCheck.split(' ');
            const dateSplited = datePart.split('/');
            return `${dateSplited[2]}-${dateSplited[1]}-${dateSplited[0]} ${time}`;
        }
    }

    getManagementPayLoad = (form: FormGroup): managementPayLoad => {
        return  {
            type: 'GIFTCARD',
            body: {
                subtype: 'GROUP',
                giftCardName: this.contributionDataResponse.giftCardName,
                giftCardAmount: {
                    amount: form.get('giftCardAmount').value.amount,
                    currency: this.contributionDataResponse.currency.code,
                    campaignId: form.get('giftCardAmount').value.campaignId 
                },
                theme: this.contributionDataResponse.theme,
                sender: {
                    name: form.get('sender').value.name,
                    email: form.get('sender').value.email
                },
                receiver: {
                    name: this.contributionDataResponse.receiverName,
                    email: this.contributionDataResponse.receiverEmail
                },
                message: this.contributionDataResponse.message,
                emailDeliveryHand: null,
                delivery: {
                    time: 'SCHEDULED',
                    dateTime: this.checkFormatDate(this.contributionDataResponse.deliveryDate)
                },
                notificationOnContribution: true
            }
        };
    };

    getInstantTranslate = (param: string): string => {
        return this.translateService.instant(param);
    };
    generateGiftCardsConfigurationInfo = (managementPayLoad: managementPayLoad) => {
        return {
            flow: 'contribution',
            giftCardName: this.contributionDataResponse.giftCardName,
            importInfo: {
                currency: this.contributionDataResponse.currency
            },
            themeGift: {
                theme: managementPayLoad.body.theme
            },
            participationCheckboxGroup: false,
            shippingInfo: {
                shippingOptionEmail: this.contributionDataResponse.receiverEmail !== null,
                shippingOptionSender: this.contributionDataResponse.deliveryHandEmail !== null,
                emailEmailSender: managementPayLoad.body.sender.email,
                emailEmailReceiver: managementPayLoad.body.receiver.email,
                delivery: {
                    dateTime: this.checkFormatDate(this.contributionDataResponse.deliveryDate)
                }
            },
            destinyGift: {
                destiny: 'other' 
            }
        };
    };
}
